import Header from "../components/Header";
import LocaleSuggestionBanner from "../components/LocaleSuggestionBanner";
import Hero from "../components/Hero";
import Clients from "../components/Clients";
import Services from "../components/Services";
import Problems from "../components/Problems";
import HowWeWork from "../components/HowWeWork";
import Engagements from "../components/Engagements";
import Expertise from "../components/Expertise";
import FounderLed from "../components/FounderLed";
import InsightsPreview from "../components/InsightsPreview";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-ink-950 text-ink-100">
      <LocaleSuggestionBanner />
      <Header />
      <main>
        <Hero />
        <Clients />
        <Services />
        <Problems />
        <HowWeWork />
        <Engagements />
        <Expertise />
        <FounderLed />
        <InsightsPreview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
